const assetIcons = {
  menu: "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/menu.svg",
  add: "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/add.svg",
  arrowDown:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/arrow-down.svg",
  arrowNext:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/arrow-next.svg",
  arrowPrevious:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/arrow-previous.svg",
  bulb: "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/bulb.svg",
  bulbDark:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/bulb-dark.svg",
  bulbLight:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/bulb-light.svg",
  check: "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/check.svg",
  cross: "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/cross.svg",
  doubleQuotes:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/double-quotes.svg",
  facebook:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/facebook.svg",
  furniture:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/furniture.svg",
  instagram:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/instagram.svg",
  light: "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/light.svg",
  linkedin:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/linkedin.svg",
  logoFooter:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/logo-footer.svg",
  logoNav:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/logo-nav.svg",
  rocket:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/rocket.svg",
  tree: "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/tree.svg",
  twitter:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/twitter.svg",
  abstractRectangle:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/abstract-rectangle.svg",
  send: "https://d1uxhsybh3036x.cloudfront.net/interior-design/svgs/send.svg",
};

const assetImages = {
  threeStep:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/pngs/3steps.png",
  brilliance:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/pngs/brilliance.png",
  hero1: "https://d1uxhsybh3036x.cloudfront.net/interior-design/pngs/hero1.png",
  hero2: "https://d1uxhsybh3036x.cloudfront.net/interior-design/pngs/hero2.png",
  reviews:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/pngs/reviews.png",
  user: "https://d1uxhsybh3036x.cloudfront.net/interior-design/pngs/user.png",
  reviewsMobile:
    "https://d1uxhsybh3036x.cloudfront.net/interior-design/pngs/reviews-mobile.png",
};

const assetVideos = {
  heroVideo: "<URL>",
  // Add more as needed
};

export { assetIcons, assetImages, assetVideos };
